export default __webpack_public_path__ + "static/media/ilustra-boneco.a624f0e7.png";